import $ from '../lib/jquery';

import { Component } from '../core/component';
import { wait } from '../helpers';
import { Slider } from '../core/slider';


export class HeroSlider extends Component {
    selector = '.js-hero-slider';

    slider = null;

    init() {
        this.$elements.each((index, element) => {
            const $element = $(element);

            const slider = new Slider(`#${$element.attr('id')}`, {
                animationDuration: 800,
                autoplay: 4000,
            });

            slider.onChange((instance, changeInfo) => {
                const $sliderImages = $element.find('.js-hero-slider-img');
                this.onChange(instance, changeInfo, $sliderImages);
            });
        });
    }

    onChange = async (instance, changeInfo, $sliderImages) => {
        const $previousImage = $sliderImages;
        const $activeImage = $($sliderImages[instance.index]);

        $previousImage.filter('.is-active.is-visible');

        if (changeInfo.direction === '>') {
            $previousImage.addClass('is-going-left');
        }

        if (changeInfo.direction === '<') {
            $previousImage.addClass('is-going-right');
        }

        $previousImage.removeClass('is-active');

        await wait(300);

        $previousImage.removeClass('is-visible is-going-right is-going-left');

        if (changeInfo.direction === '>') {
            $activeImage.addClass('is-going-right');
        }

        if (changeInfo.direction === '<') {
            $activeImage.addClass('is-going-left');
        }

        $activeImage.addClass('is-visible');

        await wait(50);

        $activeImage.addClass('is-active');

        $activeImage.removeClass('is-going-right is-going-left');
    };
}



// WEBPACK FOOTER //
// ./assets/js/components/HeroSlider.js